import React from "react";
import CarouselSkeleton from "@/src/shared/components/listing/skeletons/CarouselSkeleton";

const HostDetailsSkeleton: React.FC = () => (
  <div className="space-y-6 sm:space-y-8">
    <div className="bg-gray-100 animate-pulse rounded-2xl h-48 sm:h-64" />
    <CarouselSkeleton cardCount={6} />
  </div>
);

export default HostDetailsSkeleton;
